import { render, staticRenderFns } from "./driver_list_tbn.vue?vue&type=template&id=672d20b8&"
import script from "./driver_list_tbn.vue?vue&type=script&lang=js&"
export * from "./driver_list_tbn.vue?vue&type=script&lang=js&"
import style0 from "./driver_list_tbn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports